<script setup>
import { Toast } from '@/utils';
import { watch } from 'vue';
import { ref } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const stale = ref(false);

// hard-coded whisper token for testing
const WHISPER_TEST_TOKEN = "b0c600005d0a00157f9b08dca64d4c3d";

function joinWhisper() {
  const querySearchParams = new URLSearchParams();
  querySearchParams.set("whisperToken", WHISPER_TEST_TOKEN);
  querySearchParams.set("supervisor", "admin");

  props.modelValue.open(props.modelValue.getUrl(querySearchParams, "/w"));

  stale.value = true;
}

function copyWhisper() {
  const querySearchParams = new URLSearchParams();
  querySearchParams.set("whisperToken", WHISPER_TEST_TOKEN);
  querySearchParams.set("supervisor", "admin");

  let url = props.modelValue.getUrl(querySearchParams, "/w");
  let fullUrl = window.location.origin + url;
  props.modelValue.copy(fullUrl);

  stale.value = true;

  Toast.fire({
    icon: "success",
    title: "Copied Whisper URL",
  });
}


// when props.modelValue.rtcId changes, reset stale
watch(() => props.modelValue.rtcId, () => {
  console.log("rtcId changed, reset stale");
  stale.value = false;
});
</script>

<template>
  <v-col cols="12" v-if="!props.modelValue.userButtonEnabled && !props.modelValue.agentButtonEnabled">
    <v-btn-group style="width: 100%">
      <v-btn @click="joinWhisper()" style="flex-grow: 1" color="primary" variant="tonal" :disabled="stale">Join Whisper</v-btn>
      <v-btn @click="copyWhisper()" color="info" icon="mdi-content-copy" variant="elevated" :disabled="stale"></v-btn>
    </v-btn-group>
  </v-col>
</template>
